import React from 'react';
import { FaCheck, FaCoins, FaGift } from 'react-icons/fa';

function RewardMilestoneCard({ reward, currentPoints }) {
  const unlocked = currentPoints >= reward.milestone;
  const remaining = Math.max(0, reward.milestone - currentPoints);
  const isCalendar = reward.icon === 'calendar';

  return (
    <aside className={`reward-tile${unlocked ? ' reward-tile--unlocked' : ''}`}>
      <div className="reward-tile__milestone">
        <strong>{reward.milestone}</strong> 點
      </div>
      <div className="reward-tile__content">
        <div className="reward-tile__copy">
          <span className="reward-tile__type">{reward.type}</span>
          <span className="reward-tile__value">
            {reward.value}<small>{reward.unit}</small>
          </span>
        </div>
        <div className={`reward-tile__icon${isCalendar ? ' reward-tile__icon--calendar' : ''}`} aria-hidden="true">
          {isCalendar ? <><span>回饋</span><strong>{reward.value}{reward.unit}</strong></> : <FaGift />}
          {!isCalendar && <FaCoins className="reward-tile__coins" />}
        </div>
      </div>
      <div className={`reward-tile__status${unlocked ? ' reward-tile__status--unlocked' : ''}`}>
        {unlocked ? <><FaCheck /> 已解鎖</> : `尚差 ${remaining} 點`}
      </div>
    </aside>
  );
}

export default RewardMilestoneCard;
